import script from "./TressTheCheckout.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressTheCheckout.vue?vue&type=script&lang=ts&setup=true"

import "./TressTheCheckout.vue?vue&type=style&index=0&id=52528ea0&lang=scss"

const __exports__ = script;

export default __exports__